<template>
  <v-card
    class="mx-auto decision-card"
    :style="backgroundImageStyle"
    :maxWidth="computedMaxCardWidth"
    :minWidth="340"
  >
    <v-card-actions class="actions-area mx-1">
      <DecisionSharingDialog v-if="currentUserIsOwner" :decisionName="name" :small="true" :decisionId="decisionId" @onShared="handleShareWithUser"></DecisionSharingDialog>
      <v-spacer></v-spacer>
      <div v-if="currentProgressStep < 2">
        <div v-if="optionsCount === 1">
          <span class="status-message py-1 px-4 rounded">
            <strong>{{ optionsCount }}</strong> option added
          </span>
        </div>
        <div v-else-if="optionsCount > 1">
          <span class="status-message py-1 px-4 rounded">
            <strong>{{ optionsCount }}</strong> options built so far
          </span>
        </div>
      </div>
      <div v-if="currentProgressStep === 2">
        <span class="status-message py-1 px-4 rounded">
          <strong>{{ shortListCount }}</strong> options in the shortlist
        </span>
      </div>
    </v-card-actions>

    <!-- <v-divider></v-divider> -->

    <v-container fluid>
      <v-row>
        <!-- <v-col md="4" class="d-none d-md-flex">
          <v-stepper vertical v-model="currentProgressStep">
            <v-stepper-step :complete="currentProgressStep > 1" step="1">
              <span class="text-caption">Options</span>
            </v-stepper-step>
            <v-stepper-step :complete="currentProgressStep > 1" step="2">
              <span class="text-caption">Short List</span>
            </v-stepper-step>
            <v-stepper-step color="success" :complete="currentProgressStep > 2" step="3">
              <span class="text-caption">Decided!</span>
            </v-stepper-step>
          </v-stepper>
        </v-col> -->
        <v-col class="text-center" cols="12" @click="handleOpen">
          <!-- <div class="rounded content-area mx-4 my-4 pt-2 pb-4"> -->
          <div class="content-area">

            <div v-if="optionsCount === 0" class="text-caption">
              <div>
                <v-btn
                  dark class="my-6"
                  color="success"
                  @click="handleOpen"
                >
                  Get Started
                </v-btn>
              </div>
              This decision has no options yet
            </div>
            <div v-if="currentProgressStep === 3" class="text-caption">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      x-large
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-check
                    </v-icon>
                  </template>
                  <span>Decision made!</span>
                </v-tooltip>
              </div>
            </div>

            <!-- <div class="d-none d-md-block">
              <v-stepper v-model="currentProgressStep" alt-labels>
                <v-stepper-header>
                <v-stepper-step :complete="currentProgressStep > 1" step="1">
                  <span class="text-caption">Build Options</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentProgressStep > 1" step="2">
                  <span class="text-caption">Short List</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="success" :complete="currentProgressStep > 2" step="3">
                  <span class="text-caption">Decide!</span>
                </v-stepper-step>
              </v-stepper-header>
              </v-stepper>
            </div> -->


            <!-- <div v-if="currentProgressStep < 2">
              <div v-if="optionsCount === 1">
                <div>
                  <v-btn
                    dark class="my-6"
                    color="info"
                    @click="handleOpen"
                  >
                    Add more options
                  </v-btn>
                </div>
                <span class="status-message py-1 px-4">
                  <strong>{{ optionsCount }}</strong> option added
                </span>
              </div>
              <div v-else-if="optionsCount > 1">
                <div>
                  <v-btn
                    dark class="my-6"
                    color="primary"
                    @click="handleOpen"
                  >
                    Add more options
                  </v-btn>
                </div>
                <span class="status-message py-1 px-4">
                  <strong>{{ optionsCount }}</strong> options built so far
                </span>
              </div>
              <div v-else class="text-caption">
                <div>
                  <v-btn
                    dark class="my-6"
                    color="success"
                    @click="handleOpen"
                  >
                    Get Started
                  </v-btn>
                </div>
                This decision has no options yet
              </div>
            </div>
            <div v-if="currentProgressStep === 2">
              <div>
                <v-btn
                  dark class="my-6"
                  color="primary"
                  @click="handleOpen"
                >
                  Carry on deciding
                </v-btn>
              </div>
              <span class="status-message py-1 px-4">
                <strong>{{ shortListCount }}</strong> options in the shortlist
              </span>
            </div>
            <div v-if="currentProgressStep === 3">
              <div>
                <v-btn
                  dark class="my-6"
                  color="info"
                  @click="handleOpen"
                >
                  Review
                </v-btn>
              </div>
              <span class="status-message py-1 px-4">
                Another decision made!
              </span>
            </div> -->
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-divider></v-divider>

    <v-container fluid class="d-flex align-center title-area">
        <UserAvatar v-if="currentUserIsOwner" :displayName="ownerDisplayName" :email="ownerEmail" :photoUrl="ownerPhotoUrl" :size="40" :isCurrentUser="currentUserIsOwner" />
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="ma-2" color="white" medium>mdi-share-variant</v-icon>
          </template>
          <span>This Decision has been shared with you</span>
        </v-tooltip>

        <v-card-title class="pa-0 decision-title">
          <div
            class="title-button rounded"
            @click="handleOpen"
          >
            {{ name }}
          </div>
        </v-card-title>
    </v-container>

    <!--v-expand-transition>
      <div v-show="showDetails">
        <v-divider></v-divider>

        <v-card-text>
          TODO Details about this decision. Number of opions, progress etc.
        </v-card-text>
      </div>
    </v-expand-transition-->
  </v-card>
</template>
<script>
// @ is an alias to /src
import DecisionSharingDialog from '@/components/DecisionSharingDialog.vue'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'DecisionCard',
  components: {
    DecisionSharingDialog,
    UserAvatar
  },
  props: {
    decisionId: String,
    name: String,
    imgSrc: String,
    description: String,
    optionsCount: Number,
    shortListCount: Number,
    hasChosen: Boolean,
    currentUserIsOwner: {
      type: Boolean,
      default: false
    },
    ownerDisplayName: String,
    ownerEmail: String,
    ownerPhotoUrl: String,
    members: Object
  },
  data () {
    return {
      showDetails: false
    }
  },
  computed: {
    memberCount () {
      let res = 0
      if (this.members && Object.keys(this.members).length > 0) {
        res = Object.keys(this.members).length
      }
      return res
    },
    currentProgressStep () {
      let step = 0
      if (this.optionsCount > 0) {
        step = 1
      }
      if (this.shortListCount > 0) {
        step = 2
      }
      if (this.hasChosen) {
        step = 3
      }
      return step
    },
    backgroundImageStyle () {
      const res = {}
      if (this.imgSrc) {
        res.background = `url(${this.imgSrc}) no-repeat`
        res['background-size'] = 'cover'
        res['background-position'] = 'center center'
      }
      return res
    },
    computedMaxCardWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '100%'
        default: return '450'
      }
    },
  },
  methods: {
    handleOpen: function () {
      this.$emit('onOpen')
    },
    handleShareWithUser: function (newMemberData) {
      // Add the id for this decisoin to the share data
      //this.$emit('onShared', newMemberData)
      // TODO: add user to the local user list
      if (this.members && newMemberData.uid) {
        if (!this.members[newMemberData.uid]) {
          this.memberCount++
        }
        this.$set(this.members, newMemberData.uid, newMemberData)
      }
      // console.log(`New member was added ${JSON.stringify(newMemberData)}`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.decision-title {

}
.decision-card {

}
.title-area {
  background-color:rgba(0, 0, 0, 0.7);
  .title-button {
    text-transform: none !important;
    font-size: 1rem;
    // letter-spacing: 0.01rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
    color: #FFF;
    padding: 2px 5px;
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, 0.5)
    }
  }
}
.actions-area {
  /*background-color:rgba(255, 255, 255, 0.7);*/
  background-color: none;

  .sharing-info-text {
    background-color:rgba(255, 255, 255, 0.9);
  }
}
.content-area {
  min-height: 100px;
  cursor: pointer;
}
.status-message {
  background-color:rgba(255, 255, 255, 0.7);
  color: #222;
}
.v-stepper {
  background: none;
  border-radius: 0px;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
.v-stepper__header {
  height: auto;
}
.v-stepper__step {
  padding: 5px 12px !important;
}

.v-stepper__step__step {
    margin: 0px !important;
}
</style>
